// File: DisclaimerModal.js
import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function DisclaimerModal({ onClose }) {
  // Add animation styles if they don't exist
  useEffect(() => {
    if (!document.querySelector('#disclaimer-modal-styles')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 'disclaimer-modal-styles';
      styleSheet.textContent = `
        @keyframes fadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        @keyframes slideUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .ok-button:hover {
          background-image: linear-gradient(to right, #059669, #047857) !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 10px rgba(13, 148, 136, 0.3) !important;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 23, 42, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    backdropFilter: 'blur(8px)',
    animation: 'fadeIn 0.3s ease',
  };

  const modalContentStyle = {
    background: 'rgba(15, 23, 42, 0.8)',
    borderRadius: '1rem',
    width: '90%',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    padding: '2rem',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
    position: 'relative',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(148, 163, 184, 0.2)',
    color: 'white',
    animation: 'slideUp 0.4s ease',
  };

  const titleStyle = {
    fontSize: '1.75rem',
    fontWeight: 'bold',
    color: '#10b981',
    marginBottom: '1.5rem',
    textAlign: 'center',
    borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
    paddingBottom: '1rem',
  };

  const iframeContainerStyle = {
    borderRadius: '0.75rem',
    overflow: 'hidden',
    border: '1px solid rgba(148, 163, 184, 0.2)',
    background: 'rgba(30, 41, 59, 0.5)',
  };

  const closeButtonStyle = {
    margin: '1.5rem auto 0 auto',
    padding: '0.875rem 2rem',
    backgroundImage: 'linear-gradient(to right, #10b981, #0d9488)',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    width: 'fit-content',
  };

  const closeIconStyle = {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: 'none',
    border: 'none',
    color: '#94a3b8',
    cursor: 'pointer',
    padding: '0.5rem',
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button 
          style={closeIconStyle} 
          onClick={onClose}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#e2e8f0')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#94a3b8')}
          aria-label="Close"
        >
          <X size={24} />
        </button>
        
        <h2 style={titleStyle}>Disclaimer</h2>
        
        <div style={iframeContainerStyle}>
          <iframe
            title="Disclaimer"
            src="/disclaimer.html"
            style={{ width: '100%', height: '60vh', border: 'none' }}
          ></iframe>
        </div>
        
        <button 
          style={closeButtonStyle} 
          onClick={onClose}
          className="ok-button"
        >
          I Understand
        </button>
      </div>
    </div>
  );
}